import React from 'react';
import Loadable from '@caixue/react-loadable';
import { Loading } from 'components';

export default Loadable({
  loader: () => import('./InterstitialAdIndex'),
  loading: () => <Loading withContentWrapper />,
});

export const Form = Loadable({
  loader: () => import('./containers/InterstitialAdFormPageV2'),
  loading: () => <Loading withContentWrapper />,
});

export const Analytics = Loadable({
  loader: () => import('./InterstitialAdAnalyticsPage'),
  loading: () => <Loading withContentWrapper />,
});

export const List = Loadable({
  loader: () => import('./InterstitialAdList'),
  loading: () => <Loading withContentWrapper />,
});

export const AdExport = Loadable({
  loader: () => import('./InterstitialAdExportPage'),
  loading: () => <Loading withContentWrapper />,
});

export const Preview = Loadable({
  loader: () => import('./InterstitialAdPreviewPage'),
  loading: () => <Loading visible fullScreen />,
});
